import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { SetupService } from 'src/app/services/setup.service';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-setup-smslogs',
  templateUrl: './setup-smslogs.component.html',
  styleUrls: ['./setup-smslogs.component.css']
})
export class SetupSmslogsComponent implements OnInit {
  sms: any; smslog: any[] = []; res: any; response: any; search: string = '';
  constructor(private api: ApiService, private _setup: SetupService, private _use: NavComponent) { }

  ngOnInit() {
    this.formReset();
    this.getAllSmsLog();
    this.search = '';
  }

  getAllSmsLog() {
    this._setup.getSmslogs().subscribe((data: any) => {
      this.smslog = data.data; this.response = data;
    }, (err: HttpErrorResponse) => { alert(err.statusText); });
  }

  getMore(page,limit) {
    this.api.get('sms?search='+this.search+'&page='+page+'&limit='+limit).subscribe((data: any) => {
      this.smslog = data.data; this.response = data; // console.log(data);
    }, (err: HttpErrorResponse) => {
      this._use.showMsg('error', 'Sms List Fail', 'Unable to Fetch Sms List');
    });
  }

  retry(id) {
    this._setup.postSmslog(id).subscribe((data: any) => {
      this.res = data;
    }, (err: HttpErrorResponse) => { alert(err.statusText); });
  }

  searchData(data) {
    console.log(data);
  }

  formReset(form?: NgForm) {
    if (form != null) {
      form.reset();
    } else {
      this.sms = { id: '', muserid: this._use.active.id, mdate: new Date() };
    }
  }

}
